import { render, staticRenderFns } from "./ProvidersHistory.vue?vue&type=template&id=0b823b01&"
import script from "./ProvidersHistory.vue?vue&type=script&lang=js&"
export * from "./ProvidersHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports